import NiceModal, { useModal } from '@ebay/nice-modal-react'

import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'
import Modal from '../common/modal'
import Deposit from './deposit'
import Tabs from './tabs'
import Withdraw from './withdraw'

type WalletManagementModalProps = {
  walletManagementDefaultTab?: {
    tab?: number
    page?: number
  }
}

const WalletManagementModal = ({
  walletManagementDefaultTab,
}: WalletManagementModalProps) => {
  const modal = useModal()
  const activeTab = walletManagementDefaultTab?.tab ?? 0

  const hideModal = () => closeModal(modal)

  const showWalletManagementModal = (page?: number, tab?: number) => {
    modal.show({ walletManagementDefaultTab: { page, tab } })
  }

  return (
    <Modal
      id="wallet-management-modal"
      containerStyle={classNames(
        'w-full h-full xl:h-[unset] max-w-[unset] !p-0 !rounded-[0px] xl:!rounded-[10px] overflow-hidden !border-0 bg-primary dark:bg-primary-bg',
        activeTab === 0
          ? 'xl:w-[600px] xl:max-w-[600px]'
          : 'xl:w-[1100px] xl:max-w-[1100px]',
      )}>
      <Tabs activeTab={activeTab} hideModal={hideModal} />
      {/* Gold shimmer line */}
      <div
        className="hidden dark:block h-[3px] w-full"
        style={{
          background:
            'linear-gradient(90deg, transparent 5%, #774605 20%, #f5c542 40%, #fff8e0 50%, #f5c542 60%, #774605 80%, transparent 95%)',
        }}
      />
      <div className="hidden dark:block h-px w-full bg-[rgba(245,197,66,0.15)] shadow-[0_4px_12px_rgba(245,197,66,0.10)]" />
      {activeTab === 0 ? (
        <Deposit showWalletManagementModal={showWalletManagementModal} />
      ) : (
        <Withdraw
          closeWalletManagementModal={() => closeModal(modal)}
          showWalletManagementModal={showWalletManagementModal}
          walletManagementDefaultTab={walletManagementDefaultTab}
        />
      )}
    </Modal>
  )
}

export default NiceModal.create(WalletManagementModal)
